import React from 'react';
import { Badge, type BadgeProps } from '@mantine/core';
import { CircleHelp, Monitor, Smartphone } from 'lucide-react';

type Client = 'app' | 'web' | 'unknown' | string;

/** Label and colour for a client, shared by every place one is shown. */
export const clientLook = (client?: Client | null, legacy?: boolean) => {
  if (client === 'app') {
    return legacy
      ? { label: 'Old app', color: 'orange', icon: Smartphone }
      : { label: 'App', color: 'blue', icon: Smartphone };
  }
  if (client === 'web') {
    return legacy
      ? { label: 'Old web', color: 'yellow', icon: Monitor }
      : { label: 'Web', color: 'teal', icon: Monitor };
  }
  return { label: 'Unknown', color: 'gray', icon: CircleHelp };
};

interface ClientBadgeProps extends Omit<BadgeProps, 'color' | 'children'> {
  client?: Client | null;
  /** The old app or old web build, which does not say what it is. */
  legacy?: boolean;
}

/** Which client something came from: the app, the web dashboard, or an old build. */
const ClientBadge = ({ client, legacy, ...props }: ClientBadgeProps) => {
  const look = clientLook(client, legacy);
  return (
    <Badge
      color={look.color}
      variant="light"
      w="fit-content"
      leftSection={<look.icon size={12} aria-hidden="true" />}
      {...props}
    >
      {look.label}
    </Badge>
  );
};

export default ClientBadge;
